export default "__VITE_ASSET__379d9cc2__"